import React, { useState, useEffect } from 'react';
import { usePopper } from 'react-popper';
import { styled } from '../../../libs/styled.es.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Container = styled.div`
  [data-popper-reference-hidden] {
    visibility: hidden;
    pointer-events: none;
  }
`;
const Popper = (_a) => {
  var {
    children,
    referenceElement,
    className,
    placement,
    popperConfig: _b = {}
  } = _a, _c = _b, { modifiers = [] } = _c, rest = __objRest(_c, ["modifiers"]);
  const [popperElement, setPopperElement] = useState(null);
  const [arrowElement, setArrowElement] = useState(null);
  const { styles, attributes, update } = usePopper(referenceElement, popperElement, __spreadValues({
    placement,
    modifiers: [
      {
        name: "arrow",
        options: { element: arrowElement }
      },
      {
        name: "flip",
        enabled: true
      },
      { name: "hide" },
      ...modifiers
    ]
  }, rest));
  useEffect(() => {
    if (update) {
      update();
    }
  }, [className]);
  return /* @__PURE__ */ React.createElement(Container, __spreadProps(__spreadValues({
    ref: setPopperElement,
    style: styles.popper
  }, attributes.popper), {
    className
  }), children, /* @__PURE__ */ React.createElement("div", {
    ref: setArrowElement,
    style: styles.arrow
  }));
};

export { Popper };
